module.exports = __webpack_public_path__ + "static/media/banner1.40b9eb93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/sllaser/images/banner1.jpg
// module id = 547
// module chunks = 0